module.exports = __webpack_public_path__ + "img/cert5.48397f67.png";